/* eslint-disable react/prop-types */
import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import styled from "styled-components";
import PropTypes from "prop-types";
import SEO from "../components/seo";
import Container from "../components/container.js";
import Image from "../components/image.js";
import Columns from "../components/columns.js";
import Column from "../components/column.js";
import GutenbergBlocks from "../components/gutenberg-blocks";
import Breadcrumbs from "../components/breadcrumbs";

const Title = styled.h1`
  margin-top: 1.5rem;
  color: var(--color-primary);
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 22px;
  }
`;

const FloorSolution = ({
  data: {
    wpFloorSolution: { title, featuredImage, blocks, seo },
  },
}) => {
  return (
    <Layout itemScope itemType="https://schema.org/Blog">
      <Container maxWidth="md" disableAnimation disableMargin>
        <Breadcrumbs breadcrumbList={seo?.breadcrumbs} />
        <Columns>
          <Column width="100%" style={{ backgroundColor: "transparent" }}>
            {featuredImage?.node && (
              <Image image={featuredImage.node} itemProp="image" />
            )}
          </Column>
        </Columns>
      </Container>
      <Container maxWidth="md" disableAnimation disableMargin>
        <Title itemProp="name">{title}</Title>
        <GutenbergBlocks blocks={blocks} />
      </Container>
    </Layout>
  );
};

FloorSolution.propTypes = {
  data: PropTypes.object,
};

export default FloorSolution;

export const Head = ({
  data: {
    wpFloorSolution: { title, excerpt, featuredImage, seo },
  },
}) => {
  return (
    <SEO
      title={seo?.title || title}
      description={seo?.metaDesc || excerpt}
      breadcrumbs={seo?.breadcrumbs}
      image={featuredImage?.node?.sourceUrl}
    />
  );
};

export const query = graphql`
  query ($id: String!) {
    wpFloorSolution(id: { eq: $id }) {
      blocks {
        ...GutenbergBlocks
      }
      title
      uri
      excerpt
      seo {
        metaDesc
        title
        breadcrumbs {
          text
          url
        }
      }
      date(locale: "NO", formatString: "dddd, DD MMMM yyyy")
      modified(locale: "NO", formatString: "dddd, DD MMMM yyyy")
      featuredImage {
        node {
          sourceUrl
          focalPoint {
            objectPosition
          }
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`;
